import { toast } from "react-toastify"
import ENCategories from '../../assets/content/news/news-en'
import PTCategories from '../../assets/content/news/news-pt'
import returnLevelObject from '../../scripts/calculateLevel'
import addHatFunction from "./hatsActions"
import addAchievFunction from "./achievsActions"

const shuffler = (array) => {
    return array.sort(() => Math.random() - 0.5)
}

const startStudyGame = (language, categories) => {
    return async (dispatch) => {
        dispatch({ type: 'IS_LOADING' })
        try {
            let data = []
            let indexes = []
            let returnData = []
            let randomIndex = []

            if (language === 'pt') {
                for (const category of categories) {
                    data = data.concat(PTCategories[`${category}`])
                }
            } else {
                for (const category of categories) {
                    data = data.concat(ENCategories[`${category}`])
                }
            }

            shuffler(data)

            while (randomIndex.length < 10) {
                var r = Math.floor(Math.random() * data.length - 1) + 1;
                if (randomIndex.indexOf(r) === -1) randomIndex.push(r);
            }

            randomIndex.forEach((item) => {
                returnData.push(data[item])
                indexes.push(item)
            })

            dispatch({ type: 'START_STUDY_GAME_SUCCESS', payload: returnData })
        } catch (err) {
            dispatch({ type: 'START_STUDY_GAME_ERROR', payload: err.message })
        }
    }
}

const finishMinigame = (skip) => {
    return async (dispatch, getState, { getFirebase, getFirestore }) => {
        const maxRound = getState().studyGame.rounds
        let currentRound = getState().studyGame.currentRound
        let remainingSkips = getState().studyGame.skips
        dispatch({ type: 'IS_LOADING' })
        if (currentRound !== maxRound - 1) {
            if (skip) {
                skip -= 1
            }
            currentRound += 1
            let remainingRounds = maxRound - currentRound
            toast.success(`Minijogo concluído! Mais ${remainingRounds} minijogos para concluir esta partida.`)
            setTimeout(() => {
                dispatch({ type: 'STUDY_GAME_ROUND_COMPLETED', payload: currentRound, skips: skip || skip === 0 ? skip : remainingSkips })
            }, 600)
        } else {
            const db = getFirestore()
            const uid = getState().firebase.auth.uid
            const currentItems = getState().firebase.profile.inventory
            const userData = getState().firebase.profile
            let currentLvl = userData.level
            let currentExp = userData.experience
            let currentStatute = userData.statute
            const getMinutes = getState().studyGame.gameTime
            const expRewards = []

            if (getMinutes === 2 || getMinutes === 3) {
                expRewards.push({ exp: 25 })
            } else if (getMinutes <= 4 && getMinutes >= 8) {
                expRewards.push({ exp: 20 })
            } else if (getMinutes <= 8 && getMinutes >= 12) {
                expRewards.push({ exp: 15 })
            } else {
                expRewards.push({ exp: 35 })
            }

            try {
                const allItemsQuery = await db.collection('items').doc('bag').get()
                const allItems = allItemsQuery.data()
                const droppedItems = []

                allItems.items.forEach(item => {
                    const calculateItemDrop = (min, max) => {
                        min = Math.ceil(min)
                        max = Math.floor(max)
                        const probability = Math.floor(Math.random() * (max - min)) + min
                        const calculateDrop = Math.floor(Math.random() * Math.floor(100))
                        return calculateDrop <= probability
                    }

                    if (calculateItemDrop(1, 30)) {
                        droppedItems.push(item)
                    } else {
                        droppedItems.push(null)
                    }
                })

                const filteredDroppedItems = droppedItems.filter((el) => el != null)
                const updateBag = droppedItems.length >= 1 ? [...currentItems.bag, ...filteredDroppedItems] : currentItems.bag

                const studyGameNumber = userData.studyGame += 1
                const updateExperience = currentExp += expRewards[0].exp
                const getLevel = currentLvl === 10 ? null : returnLevelObject(updateExperience, currentLvl)
                const getLevelProps = getLevel ? Object.keys(getLevel).length : null

                if (getLevelProps && getLevelProps !== 2) {
                    toast.success(getLevel.lvlMessage)
                }

                await db.collection('users').doc(uid).update({
                    experience: updateExperience,
                    experiencePercentage: !getLevel && currentLvl === 10 ? 100 : getLevel.lvlPercentage,
                    level: !getLevel ? currentLvl : getLevel.level,
                    statute: getLevelProps?.statute ? getLevelProps.statute : currentStatute,
                    studyGame: studyGameNumber,
                    inventory: {
                        hats: [...currentItems.hats],
                        bag: updateBag
                    }
                })

                dispatch(addAchievFunction(['worldnewsgame', 'achievements', 'inventory-bag']))
                dispatch(addHatFunction())
                dispatch({ type: 'STUDY_GAME_COMPLETED_SUCCESS', payload: { exp: expRewards[0].exp, score: expRewards[0].score, items: filteredDroppedItems } })

            } catch (err) {
                console.log(err)
                dispatch({ type: 'STUDY_GAME_COMPLETED_ERROR', payload: err.message })
            }
        }
    }
}

const quitGame = () => {
    return {
        type: 'QUIT_GAME'
    }
}

const removeFeedback = () => {
    return (dispatch) => {
        dispatch({ type: 'REMOVE_FEEDBACK' })
    }
}

export default {
    startStudyGame,
    finishMinigame,
    quitGame,
    removeFeedback
}
